class ClientApi {
  static setLastGeneratedMember(data) {
    return data;
  }

  static setClientSelectorClient(client) {
    return client;
  }
}

export default ClientApi;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/clientApi.js